import { createAction } from '@atc/modular-redux';
import { applyFilterGroups } from './helpers';

/* eslint-disable */
export default _ref => {
  let {
    types
  } = _ref;
  return {
    addError: createAction(types.ADD_ERROR),
    addFiltersOptions: function (payload) {
      if (payload === void 0) {
        payload = {};
      }
      return {
        type: types.ADD_FILTERS_OPTIONS,
        payload: applyFilterGroups(payload)
      };
    },
    applyFilterChange: function (event, filter, grouped) {
      if (event === void 0) {
        event = {};
      }
      return dispatch => {
        const {
          target = {}
        } = event;
        // set is multiple off of elements multiple attribute
        const isMultiple = grouped || target.multiple;
        let actionType = types.SELECT_FILTER;
        let {
          type = '',
          checked = false,
          value
        } = target;
        if (type.toLowerCase() === 'checkbox' && !checked) {
          // boolean checkboxes should "select" an off value
          if (!isMultiple) {
            actionType = types.SELECT_FILTER;
            value = 'off';
          } else {
            actionType = types.DESELECT_FILTER;
          }
        }
        dispatch({
          type: actionType,
          payload: {
            value,
            filter,
            isMultiple
          }
        });
      };
    },
    clearActiveExpansion: createAction(types.CLEAR_ACTIVE_EXPANSION),
    clearFilter: createAction(types.CLEAR_FILTER),
    clearFilters: createAction(types.CLEAR_FILTERS),
    clearLastTouchedFilter: createAction(types.CLEAR_LAST_TOUCHED_FILTER),
    deselectFilter: createAction(types.DESELECT_FILTER),
    hideFilters: createAction(types.HIDE_FILTERS),
    selectFilter: createAction(types.SELECT_FILTER),
    selectFilters: createAction(types.SELECT_FILTERS),
    setActiveExpansion: createAction(types.SET_ACTIVE_EXPANSION),
    setFiltersOptions: function (payload) {
      if (payload === void 0) {
        payload = {};
      }
      return {
        type: types.SET_FILTERS_OPTIONS,
        payload: applyFilterGroups(payload)
      };
    },
    setFiltersValues: createAction(types.SET_FILTERS_VALUES),
    showFilters: createAction(types.SHOW_FILTERS),
    removeActiveExpansion: createAction(types.REMOVE_ACTIVE_EXPANSION),
    removeError: createAction(types.REMOVE_ERROR)
  };
};